export default __webpack_public_path__ + "static/media/restaurants.f173b18f.svg";